import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick", "data-cy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                height: "40px",
                elevation: "0",
                class: "rounded-lg gradient",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'new-engagement-letter' }))),
                "data-cy": "EngagementLetters-add"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedStatus,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                items: _ctx.status,
                "item-title": "text",
                "item-value": "value",
                label: "Filtrer par statut",
                "hide-details": "",
                "data-cy": "EngagementLetters-statut",
                density: "compact"
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                "hide-details": "",
                "data-cy": "EngagementLetters-search",
                density: "compact",
                "append-inner-icon": "$fa-search",
                clearable: "",
                "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = ''))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "1",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TutorialButtonDialog, { starterComponents: 'EngagementLetters;' })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engagementLetters, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              class: "py-2",
              cols: "8",
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_item, { class: "d-flex align-center justify-space-between position-relative" }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-2 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "$oss-letter",
                                  onClick: ($event: any) => (_ctx.setRouter(item.id)),
                                  class: "mr-2",
                                  color: "primary",
                                  size: "36"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { class: "d-flex flex-column justify-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "primary--text",
                                  style: {"white-space":"nowrap"},
                                  onClick: ($event: any) => (_ctx.setRouter(item.id))
                                }, _toDisplayString(_ctx.getTitle(item)), 9, _hoisted_1),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    location: "start",
                                    class: "mr-1",
                                    onClick: ($event: any) => (_ctx.setRouter(item.id))
                                  }, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode(" $oss-outlined-user ")
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.getAccountant(item)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex position-absolute",
                          style: {"left":"45%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              class: "d-flex align-center justify-center",
                              style: {"white-space":"nowrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "small",
                                  color: "primary",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode(" $oss-calendar ")
                                  ])),
                                  _: 1
                                }),
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.setRouter(item.id)),
                                  class: "text-overline font-text-statut",
                                  "data-cy": `EngagementLetters-statut-${item.id}`
                                }, _toDisplayString(_ctx.$t("engagementLetter.status." + item.status)), 9, _hoisted_2)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      append: _withCtx(() => [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "d-flex justify-center py-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "10",
                                  class: "pt-1 pb-1",
                                  style: {"width":"100px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      block: "",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.setRouter(item.id)),
                                      "data-cy": `EngagementLetters-edit-${item.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.status === "DRAFT" ? "Editer" : "Accéder"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "data-cy"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "10",
                                  class: "pt-1 pb-1"
                                }, {
                                  default: _withCtx(() => [
                                    (item.status !== 'SIGNED')
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 0,
                                          variant: "outlined",
                                          block: "",
                                          color: "error",
                                          onClick: _withModifiers(($event: any) => (_ctx.confirmDeleteEngagementLetter(item)), ["stop"]),
                                          size: "small",
                                          style: {"min-width":"100%"}
                                        }, {
                                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode(" Supprimer ")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.deleteDialog,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deleteDialog) = $event)),
            title: "Supprimer une lettre de mission",
            onValid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteEngagementLetter())),
            "valid-title": "Confirmer",
            width: "40vw"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "px-2" }, "Êtes-vous sur de supprimer la lettre de mission ?", -1)
            ])),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}